export default "__VITE_ASSET__yjnvPJm1__"